import React, { Component } from 'react'
import Table from "../../../components/UI/Table/Table";
import { tableColumns, DEFAULT_PAGE_SIZE } from '../constants';

class SectionTemplateTableView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks
            })
        }
    }

    render() {
        return (
            <Table
                data={this.props.data.billingFilterResponses}
                columns={tableColumns}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                loading={this.props.loading}
                /* defaultSorted={[
                    {
                        id: "taskName",
                        desc: false
                    }
                ]} */
                noDataText="No cases found"
                multiSort={false}
                pages={this.props.data.noOfPages}
                
                manual  
                onPageChange={(pageIndex) => { 
                    this.setState({
                        currentPageIndex: pageIndex
                    });
                    this.props.onFetchPage(pageIndex, DEFAULT_PAGE_SIZE, this.state.sorted);
                }}
                onSortedChange={(newSorted, column, shiftKey) => { 
                    this.setState({
                        sorted: newSorted[0]
                    });
                    this.props.onFetchPage(0, DEFAULT_PAGE_SIZE, newSorted[0]);
                }}
            />
        )
    }
}

export default SectionTemplateTableView